module.exports = __webpack_public_path__ + "img/doctorbanner.ad1c46f9.jpg";